import { action, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { Iui } from '../../';
import { ITranslation } from '../../locales';
import { getLocale } from '../../../utils/pathHelper';

@inject('t', 'ui')
@observer
class SearchPanel extends React.Component<{ t?: ITranslation, ui?: Iui }> {
  constructor(props: { t?: ITranslation, ui?: Iui }) {
    super(props);
    makeObservable(this);
  }

  public render() {
    const { t, ui } = this.props;
    const { byAccess } = ui;
    return (
      <div className="resort-search__panel">
        <div className="resort-search__field">
          <div className="resort-search__select">
            <select value={byAccess.originIndex} onChange={this.update('originIndex')}>
              {byAccess.origins.map((origin, i) => (
                <option key={origin.place_id} value={i}>{origin[`name_${getLocale({ underscore: true })}`]}</option>
              ))}
            </select>
            <div className="resort-search__select-arrow"></div>
          </div>
        </div>
        <div className="resort-search__field">
          <div className="resort-search__select">
            <select value={byAccess.duration} onChange={this.update('duration')}>
              {[90, 120, 180, 240].map((min, i) => (
                <option key={min} value={min}>{min/60}</option>
              ))}
            </select>
            <div className="resort-search__select-arrow"></div>
          </div>
          <p>{t.accessHours()}</p>
        </div>
        <div className="resort-search__field">
          {this.renderButton()}
        </div>
      </div>
    );
  }

  public renderButton() {
    const { t, ui } = this.props;
    const { byAccess } = ui;
    const { resorts } = byAccess;
    if (byAccess.isLoading || resorts.length === 0) {
      return (
        <a className="resort-search__btn disabled" href="" onClick={(e) => { e.preventDefault(); return false; }}>
          {byAccess.isLoading ? <i className="fa fa-spinner fa-spin mx-1" /> : t.resortFound({ count: 0 })}
        </a>
      );
    }
    return (
      <a className="resort-search__btn" href={byAccess.resortListPath}>
        {t.resortFound({ count: byAccess.resorts.length })}
        <i className="fas fa-arrow-right ml-2" style={{ marginRight: -6 }} />
      </a>
    );
  }

  @action.bound
  public update(fieldKey: string): (e: any) => void {
    const { byAccess } = this.props.ui;

    return (e: any) => {
      byAccess.access.path = [];
      byAccess[fieldKey] = e.target.value;
      if (fieldKey === 'originIndex') {
        const origin = byAccess.currentOrigin;
        byAccess.mapCenter = { lat: Number(origin.latitude), lng: Number(origin.longitude) };
      }
      byAccess.update();
    }
  }
}

export default SearchPanel;
